export default "__VITE_ASSET__C5XA6hh8__"